import Formsy from 'formsy-react-2';
import React from 'react';
import css from './style.scss'
import cn from 'classnames'
class Input extends Formsy.Mixin {
  static defaultProps = {
    type: 'text'
  }
  updateValue = (event) => {
    this.setValue(event.target.value);
  }

  render() {
    const {type, fullWidth, ...rest} = this.removeFormsyProps(this.props);
    const errorMessage = this.getErrorMessage();
    return (
      <div className={cn(css.input, fullWidth? css.fullWidth : "")}>
        <label>{this.props.label}</label>
        <input {...rest} type={type} value={this.getValue()} onChange={this.updateValue} />
        <span>{errorMessage}</span>
        <small>{this.props.message}</small>
      </div>
    )
  }
}

export class NormalInput extends React.Component {
  static defaultProps = {
    type: 'text'
  }
  focus(){
    this.input.focus()
  }
  render() {
    const {type, fullWidth, big, ...rest} = this.props;
    return (
      <div className={cn(css.input, big? css.big :"" , fullWidth? css.fullWidth : "")}>
        {this.props.label && <label>{this.props.label}</label>}
        <input autocomplete="false" {...rest} ref={(i)=>this.input=i}type={type} value={this.props.value ? this.props.value : undefined} onChange={this.props.onChange} />
      </div>
    )
  }
}


export default Input;



// WEBPACK FOOTER //
// ./src/components/shared/input/index.js